// src/shared/services/app.ts
// Service to provide app info such as version from package.json

import { ref } from 'vue';

// Vite exposes custom env variables via import.meta.env.VITE_*
// You must define VITE_APP_VERSION in your vite.config.ts

export function useAppInfo() {
  // Defensive: fallback to '0.0.0' if not found
  const appVersion = ref<string>(import.meta.env.VITE_APP_VERSION ?? '0.0.0');
  return { appVersion };
}
